export default {
    initialpaystate: {
        disablepay: true,
        firstname: "",
        lastname: "",
        email: ""
    },

    initialDialogstate: {
        open: false,
        dialogetitle: "",
        dialogemessage: "",
    },


    initialerrorhandler: {
        open: false,
        dialogemessage: "",
    }

}